import { render } from "./emailTemplate.vue?vue&type=template&id=16bebd4b&ts=true"
import script from "./emailTemplate.vue?vue&type=script&lang=ts"
export * from "./emailTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__